const validate = values => {
    const errors = {};
    if (!values.comment) {
        errors.comment = 'Please enter your comment';
    }
    if (values.comment && values.comment.length > 300) {
        errors.comment = 'Cannot be more than 300 characters';
    }
    return errors;
};

export default validate;
